var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-slots"},[(_vm.moduleIsReady)?_c('router-view'):_c('div',{staticClass:"center-loader"},[_c('loaderGeneric')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }